import { render, staticRenderFns } from "./memberTable.vue?vue&type=template&id=3894999b&"
import script from "./memberTable.vue?vue&type=script&lang=ts&"
export * from "./memberTable.vue?vue&type=script&lang=ts&"
import style0 from "./memberTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports